// AUTO-GENERATED FROM scripts/data/ready-made-insoles.csv.
// Run `node scripts/generate-ready-made-catalog.mjs` to regenerate.
// Do not edit by hand.

export type ReadyMadeFamily =
  | "Ready-Made Insoles";

export interface ReadyMadeProduct {
  family: ReadyMadeFamily;
  /** Internal SKU, e.g. "CAPE". */
  code: string;
  productName: string;
  description: string;
  /** Size labels in display order, e.g. "Size 38". */
  sizes: readonly string[];
  /** Filename inside apps/web/public/products/ready-made/. */
  image: string;
}

export const READY_MADE_FAMILIES: readonly ReadyMadeFamily[] = [
  "Ready-Made Insoles",
];

export const READY_MADE_PRODUCTS: readonly ReadyMadeProduct[] = [
  {
    family: "Ready-Made Insoles",
    code: "CAPE",
    productName: "CAPE - CALCA PRO X",
    description: "Ready-made insole with fibreglass shell. Rigid biomechanical support in a thin, durable profile. Indicated for plantar fasciitis, geriatric foot and diabetic foot.",
    sizes: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "CAPE.png",
  },
  {
    family: "Ready-Made Insoles",
    code: "CA2E",
    productName: "CA2E - CALCA II",
    description: "Ready-made insole built on a fibreglass shell, specifically tuned for heel-region pathologies. Lightweight rigid support with proven durability. For heel spurs and plantar heel pain.",
    sizes: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "CA2E.png",
  },
  {
    family: "Ready-Made Insoles",
    code: "DAHE",
    productName: "DAHE - DAILY HIGH HEEL",
    description: "Ready-made insole for high-heel footwear, built on a carbon fibre shell. Engineered to occupy minimal space inside narrow elevated shoes while delivering biomechanical control.",
    sizes: [
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
    ],
    image: "DAHE.png",
  },
  {
    family: "Ready-Made Insoles",
    // Data-bug fix (migration 20270213000000): the code carried a spurious "2"
    // so "KIK2"+"23" produced KIK223; the real Mondopoint size is 23, sku KIK23.
    code: "KIK",
    productName: "KID CONTROL",
    description: "Ready-made pediatric insole with fibreglass shell that occupies minimal space. Designed for children's growing feet requiring pronation/supination biomechanical guidance.",
    sizes: [
      "Size 23",
      "Size 24",
      "Size 25",
      "Size 26",
      "Size 27",
      "Size 28",
      "Size 29",
      "Size 30",
      "Size 31",
      "Size 32",
      "Size 33",
      "Size 34",
      "Size 35",
      "Size 36",
    ],
    image: "KIK2.png",
  },
  {
    family: "Ready-Made Insoles",
    code: "CLOB",
    productName: "CLOB - CLEVER soft",
    description: "Ready-made insole in thermoformable EVA. Heat-moldable for a fully adaptable, soft accommodative fit. Indicated for sensitive feet, comfort needs and gentle daily wear.",
    sizes: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "CLOB.png",
  },
  {
    family: "Ready-Made Insoles",
    code: "HAGL",
    productName: "HAGL - Haglund Device",
    description: "Ready-made Haglund deformity device. Offloads and cushions the posterior heel. Indicated for Haglund deformity, retrocalcaneal bursitis and posterior heel pain.",
    sizes: [
      "Size Small (EU 24-40)",
      "Size Large (EU 41-46)",
    ],
    image: "HAGL.png",
  },
];

export const READY_MADE_IMAGE_BASE = '/products/ready-made';
